import { Meta, StoryObj } from "@storybook/nextjs-vite";
import { HorizontalFilter } from "./HorizontalFilter";

const meta: Meta<typeof HorizontalFilter> = {
  title: "Horizontal filter",
  component: HorizontalFilter,
};

export default meta;

export const Default: StoryObj<typeof HorizontalFilter> = {
  args: {
    filters: [
      {
        label: "Filter 1",
        name: "filter1",
        categories: [
          {
            type: "leaf",
            name: "Category 1",
          },
          {
            type: "leaf",
            name: "Category 2",
          },
          {
            type: "intermediate",
            name: "Subcategory 1",
            children: [
              {
                type: "leaf",
                name: "Nested category 1",
              },
              {
                type: "leaf",
                name: "Nested category 2",
              },
            ],
          },
          {
            type: "intermediate",
            name: "Subcategory 2",
            children: [
              {
                type: "leaf",
                name: "Nested category 1",
              },
              {
                type: "leaf",
                name: "Nested category 2",
              },
            ],
          },
          {
            type: "intermediate",
            name: "Subcategory 3",
            children: [
              {
                type: "leaf",
                name: "Nested category 1",
              },
              {
                type: "leaf",
                name: "Nested category 2",
              },
            ],
          },
        ],
        multiple: true,
      },
      {
        label: "Filter 2",
        name: "filter2",
        categories: [
          {
            type: "leaf",
            name: "Category 1",
          },
          {
            type: "leaf",
            name: "Category 2",
          },
          {
            type: "intermediate",
            name: "Subcategory 1",
            children: [
              {
                type: "leaf",
                name: "Nested category 1",
              },
              {
                type: "leaf",
                name: "Nested category 2",
              },
            ],
          },
          {
            type: "intermediate",
            name: "Subcategory 2",
            children: [
              {
                type: "leaf",
                name: "Nested category 1",
              },
              {
                type: "leaf",
                name: "Nested category 2",
              },
            ],
          },
          {
            type: "intermediate",
            name: "Subcategory 3",
            children: [
              {
                type: "leaf",
                name: "Nested category 1",
              },
              {
                type: "leaf",
                name: "Nested category 2",
              },
            ],
          },
        ],
        multiple: false,
      },
      {
        label: "Filter 3",
        name: "filter3",
        categories: [
          {
            type: "leaf",
            name: "Category 1",
          },
          {
            type: "leaf",
            name: "Category 2",
          },
          {
            type: "intermediate",
            name: "Subcategory 1",
            children: [
              {
                type: "leaf",
                name: "Nested category 1",
              },
              {
                type: "leaf",
                name: "Nested category 2",
              },
            ],
          },
          {
            type: "intermediate",
            name: "Subcategory 2",
            children: [
              {
                type: "leaf",
                name: "Nested category 1",
              },
              {
                type: "leaf",
                name: "Nested category 2",
              },
            ],
          },
          {
            type: "intermediate",
            name: "Subcategory 3",
            children: [
              {
                type: "leaf",
                name: "Nested category 1",
              },
              {
                type: "leaf",
                name: "Nested category 2",
              },
            ],
          },
        ],
        multiple: false,
      },
    ],
    selectedFilters: [],
  },
};
